import React from "react";

export class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer className="footer">
        <div className="footer_copyright">&copy;{new Date().getFullYear()} </div>
        <div className="footer_byline">CORIPORT</div>
      </footer>
    );
  }
}
